import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';
import ShimmerEmptyImageTextComponent from './shimmerEmptyImageTextComponent';
import EmptyUnReadMsg from '../../../../../assets/svgComponents/EmptyUnReadMsg';

import './overviewUnReadMessagesShimmerComponent.css';

const OverviewUnReadMessagesShimmerComponent = ({showShimmer = true}) => {
  return (
    <>
      {showShimmer ? (
        <>
          {Array.from({length: 3}).map((val, idx) => (
            <div key={idx} className="et-v2-overview-un-read-msg-shimmer-wrap">
              <ShimmerComponent />
            </div>
          ))}
        </>
      ) : (
        <div className="et-v2-overview-un-read-msg-empty-shimmer-wrap">
          <ShimmerEmptyImageTextComponent
            ImageComponent={EmptyUnReadMsg}
            titleTxt="No new messages"
            subTitleTxt="You currently have no unread messages"
          />
        </div>
      )}
    </>
  );
};

export default OverviewUnReadMessagesShimmerComponent;
